module.exports = __webpack_public_path__ + "img/board-chair.24aebf25.png";